export default __webpack_public_path__ + "static/media/info.cfe77e58.svg";